export default [
  ['México', 'MX'],
  ['Albania', 'AL'],
  ['Alemania', 'DE'],
  ['Andorra', 'AD'],
  ['Angola', 'AO'],
  ['Anguila', 'AI'],
  ['Antigua Y Barbuda', 'AG'],
  ['Antillas Holandesas', 'AN'],
  ['Arabia Saudita', 'SA'],
  ['Argelia', 'DZ'],
  ['Argentina', 'AR'],
  ['Armenia', 'AM'],
  ['Aruba', 'AW'],
  ['Australia', 'AU'],
  ['Austria', 'AT'],
  ['Azerbayan', 'AZ'],
  ['Bahamas', 'BS'],
  ['Bahrein', 'BH'],
  ['Bangladesh', 'BD'],
  ['Barbados', 'BB'],
  ['Belgica', 'BE'],
  ['Belice', 'BZ'],
  ['Benin', 'BJ'],
  ['Bermudas', 'BM'],
  ['Bielorrusia', 'BY'],
  ['Bolivia', 'BO'],
  ['Bonaire', 'BES'],
  ['Bosnia', 'BA'],
  ['Botsuana', 'BW'],
  ['Brasil', 'BR'],
  ['Brunei', 'BN'],
  ['Bulgaria', 'BG'],
  ['Burkina Faso', 'BF'],
  ['Burundi', 'BI'],
  ['Butan', 'BT'],
  ['Cabo Verde', 'CV'],
  ['Camboya', 'KH'],
  ['Camerun', 'CM'],
  ['Canada', 'CA'],
  ['Chad', 'TD'],
  ['Chile', 'CL'],
  ['China', 'CN'],
  ['Chipre', 'CY'],
  ['Ciudad del Vaticano', 'VA'],
  ['Colombia', 'CO'],
  ['Congo', 'CG'],
  ['Corea del Sur', 'KR'],
  ['Costa de Marfil', 'CI'],
  ['Costa Rica', 'CR'],
  ['Croacia', 'HR'],
  // ['Curacao', 'CW'],
  ['Curazao', 'CW'],
  ['Dinamarca', 'DK'],
  ['Djibouti', 'DJ'],
  ['Dominica', 'DM'],
  ['Ecuador', 'EC'],
  ['Egipto', 'EG'],
  ['El Salvador', 'SV'],
  ['Emiratos Arabes Unidos', 'AE'],
  ['Eritrea', 'ER'],
  ['Escocia', 'SKT'],
  ['Eslovenia', 'SI'],
  ['España', 'ES'],
  ['Estados Unidos', 'US'],
  ['Estonia', 'EE'],
  ['Etiopia', 'ET'],
  ['Fiji', 'FJ'],
  ['Filipinas', 'PH'],
  ['Finlandia', 'FI'],
  ['Francia', 'FR'],
  ['Gabon', 'GA'],
  ['Gales', 'WAL'],
  ['Gambia', 'GM'],
  ['Georgia', 'GE'],
  ['Ghana', 'GH'],
  ['Gibraltar', 'GI'],
  ['Granada', 'GD'],
  ['Grecia', 'GR'],
  ['Groenlandia', 'GL'],
  ['Guadalupe', 'GP'],
  ['Guam', 'GU'],
  ['Guatemala', 'GT'],
  ['Guayana', 'GY'],
  ['Guayana Francesa', 'GF'],
  ['Guinea Bissau', 'GW'],
  ['Guinea', 'GN'],
  ['Guinea Ecuatorial', 'GQ'],
  ['Haiti', 'HT'],
  ['Holanda', 'NT'],
  ['Honduras', 'HN'],
  ['Hong Kong', 'HK'],
  ['Hungria', 'HU'],
  ['India', 'IN'],
  ['Indonesia', 'ID'],
  ['Inglaterra', 'GB'],
  ['Irak', 'IQ'],
  ['Irlanda', 'IE'],
  ['Irlanda del Norte', 'IEN'],
  ['Islandia', 'IS'],
  ['Islas Caiman', 'KY'],
  ['Islas Cook', 'CK'],
  ['Islas Faroe', 'FO'],
  ['Islas Marshall', 'MH'],
  ['Islas Vírgenes Britanicas', 'VG'],
  ['Islas Virgenes EUA', 'VI'],
  ['Israel', 'IL'],
  ['Italia', 'IT'],
  ['Jamaica', 'JM'],
  ['Japon', 'JP'],
  ['Jordania', 'JO'],
  ['Kazajstán', 'KZ'],
  ['Kenia', 'KE'],
  ['Kirguizistan', 'KG'],
  ['Kuwait', 'KW'],
  ['Laos', 'LA'],
  ['Latvia', 'LV'],
  ['Lesoto', 'LS'],
  ['Libano', 'LB'],
  ['Liberia', 'LR'],
  ['Liechtenstein', 'LI'],
  ['Lituania', 'LT'],
  ['Luxemburgo', 'LU'],
  ['Macao', 'MO'],
  ['Macedonia', 'MK'],
  ['Madagascar', 'MG'],
  ['Malasia', 'MY'],
  ['Malaui', 'MW'],
  ['Maldivia', 'MV'],
  ['Mali', 'ML'],
  ['Malta', 'MT'],
  ['Marruecos', 'MA'],
  ['Martinica', 'MQ'],
  ['Mauricio', 'MU'],
  ['Mauritania', 'MR'],
  ['Micronesia', 'FM'],
  ['Moldovia', 'MD'],
  ['Monaco', 'MC'],
  ['Mongolia', 'MN'],
  ['Montserrat', 'MS'],
  ['Mozambique', 'MZ'],
  ['Myanmar', 'MM'],
  ['Namibia', 'NA'],
  ['Nepal', 'NP'],
  ['Nicaragua', 'NI'],
  ['Niger', 'NE'],
  // ['Nigeria', 'NG'],
  ['Noruega', 'NO'],
  ['Nueva Caledonia', 'NC'],
  ['Nueva Zelanda', 'NZ'],
  ['Omán', 'OM'],
  ['Pakistan', 'PK'],
  ['Palaos', 'PW'],
  ['Palestina', 'PS'],
  ['Panama', 'PA'],
  ['Papua Nueva Guinea', 'PG'],
  ['Paraguay', 'PY'],
  ['Peru', 'PE'],
  ['Polinesia Francesa', 'PF'],
  ['Polonia', 'PL'],
  ['Portugal', 'PT'],
  ['Puerto Rico', 'PR'],
  ['Qatar', 'QA'],
  ['Reino Unido', 'UK'],
  ['Rep Democratica del Congo', 'CD'],
  ['Republica Checa', 'CZ'],
  ['Republica Dominicana', 'DO'],
  ['Republica Eslovaca', 'SK'],
  ['Reunion', 'RE'],
  ['Ruanda', 'RW'],
  ['Rumania', 'RO'],
  ['Rusia', 'RU'],
  ['Saba', 'BQ'],
  ['Saipan', 'MP'],
  ['Samoa Americana', 'AS'],
  ['San Bartolome', 'BL'],
  ['San Cristobal y Nevis', 'KN'],
  ['San Eustaquio', 'SBQ'],
  ['San Marino', 'SM'],
  ['San Martín', 'MF'],
  ['San Vicente', 'VC'],
  ['Santa Lucia', 'LC'],
  ['Senegal', 'SN'],
  ['Serbia y Montenegro', 'RS'],
  ['Seychelles', 'SC'],
  ['Sierra Leona', 'SL'],
  ['Singapur', 'SG'],
  ['Siria', 'SY'],
  ['Somalia', 'SO'],
  ['Sri Lanka', 'LK'],
  ['Suazilandia', 'SZ'],
  ['Sudafrica', 'ZA'],
  ['Sudan', 'SD'],
  ['Suecia', 'SE'],
  ['Suiza', 'CH'],
  ['Surinam', 'SR'],
  ['Tailandia', 'TH'],
  ['Taiwan', 'TW'],
  ['Tanzania', 'TZ'],
  ['Timor Este', 'TL'],
  ['Togo', 'TG'],
  ['Trinidad y Tobago', 'TT'],
  ['Tunez', 'TN'],
  ['Turcos y Caicos', 'TC'],
  ['Turkmenistan', 'T'],
  ['Turquia', 'TR'],
  ['Ucrania', 'UA'],
  ['Uganda', 'UG'],
  ['Uruguay', 'UY'],
  ['Uzbekistan', 'UZ'],
  ['Vanuatu', 'VU'],
  ['Venezuela', 'VE'],
  ['Vietnam', 'VN'],
  ['Wallis y Futuna', 'WF'],
  ['Yemen', 'YE'],
  ['Yugoslavia', 'YU'],
  ['Zaire', 'ZR'],
  ['Zambia', 'ZM'],
  ['Zimbawe', 'ZW'],
];
